export default __webpack_public_path__ + "eddf6d559d647df95a63f8516c26a145.png";